<template>
  <div class="pcm-a-wrapper" id="pcm-wrapper">
    <img class="pcm-a-bg" src="@/assets/images/landingA/bg.webp" alt="" />
    <!-- 人物轮播（渐入渐出） -->
    <img
      v-for="(item, index) in slides"
      :key="index"
      class="pcm-a-slide"
      :class="{ active: activeIndex === index }"
      :src="item"
      alt=""
    />
    <img class="pcm-a-title" src="@/assets/images/landingA/title.webp" alt="" />
    <!-- 二维码 -->
    <div class="pcm-a-qr-panel">
      <img class="pcm-a-qr-bg" src="@/assets/images/landingA/qr.webp" alt="" />
      <img class="pcm-a-qr" :src="qrImg" alt="" />
    </div>
    <div class="pcm-a-covers" aria-hidden="true">
      <div
        v-for="(item, index) in covers"
        :key="item"
        class="pcm-a-cover"
        :class="{ featured: index === 0 }"
      >
        <img
          class="pcm-a-cover-frame"
          src="@/assets/images/landingA/cardframe.webp"
          alt=""
        />
        <img class="pcm-a-cover-image" :src="item" alt="" />
      </div>
    </div>
    <div class="pcm-a-header">
      <!-- 顶部 logo -->
      <div class="pcm-a-logo">
        <img
          class="pcm-a-logo-icon"
          src="@/assets/images/landingA/pclogoicon.webp"
          alt=""
        />
        <img
          class="pcm-a-logo-type"
          src="@/assets/images/landingA/pclogotype.webp"
          alt="熟果短剧"
        />
      </div>

      <!-- 联系方式 -->
      <div class="pcm-a-services">
        <img
          v-if="swUrl"
          class="pcm-a-service"
          src="@/assets/images/landingA/pcsw.webp"
          @click="toContact(swUrl)"
          alt=""
        />
        <img
          v-if="qdUrl"
          class="pcm-a-service"
          src="@/assets/images/landingA/pcqd.webp"
          @click="toContact(qdUrl)"
          alt=""
        />
        <img
          v-if="tgUrl"
          class="pcm-a-service"
          src="@/assets/images/landingA/pctg.webp"
          @click="toContact(tgUrl)"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import autofit from "autofit.js";

export default {
  props: ["qrImg", "configs", "version"],
  data() {
    return {
      tgUrl: "",
      potatoUrl: "",
      swUrl: "",
      qdUrl: "",
      activeIndex: 0,
      slideTimer: null,
      slides: [1, 2, 3, 4].map(index =>
        require(`@/assets/images/landingA/person${index}.webp`)
      ),
      covers: [1, 2, 3, 4].map(index =>
        require(`@/assets/images/landingA/cover${index}.webp`)
      )
    };
  },
  watch: {
    configs(newValue) {
      newValue.forEach(item => {
        if (item.configType == "tg_group") {
          this.tgUrl = item.link;
        } else if (item.configType == "potato_group") {
          this.potatoUrl = item.link;
        } else if (item.configType == "sw_cooperate") {
          this.swUrl = item.link;
        } else if (item.configType == "qd_cooperate") {
          this.qdUrl = item.link;
        }
      });
      return newValue;
    }
  },
  mounted() {
    autofit.init(
      {
        dh: 1080.574,
        dw: 1920,
        el: "#pcm-wrapper",
        resize: true
      },
      false
    );
    this.startRotation();
  },
  beforeDestroy() {
    this.stopRotation();
    autofit.off("#pcm-wrapper");
  },
  methods: {
    startRotation() {
      this.stopRotation();
      this.slideTimer = setInterval(() => {
        this.activeIndex = (this.activeIndex + 1) % this.slides.length;
      }, 3500);
    },
    stopRotation() {
      if (this.slideTimer) {
        clearInterval(this.slideTimer);
        this.slideTimer = null;
      }
    },
    toContact(url) {
      window.open(url);
    }
  }
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}
.pcm-a-wrapper {
  width: 1920px;
  height: 1080.574px;
  overflow: hidden;
  position: relative;
  background: #1a0308;
  .pcm-a-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    pointer-events: none;
  }
  .pcm-a-slide {
    position: absolute;
    left: 990.43px;
    top: 157.56px;
    width: 853.74px;
    height: 670.74px;
    z-index: 2;
    opacity: 0;
    transition: opacity 0.8s ease;
    pointer-events: none;
    &.active {
      opacity: 1;
    }
  }
  .pcm-a-title {
    position: absolute;
    left: 154.38px;
    top: 172.26px;
    width: 856.88px;
    height: 533.87px;
    z-index: 3;
    pointer-events: none;
  }
  .pcm-a-qr-panel {
    position: absolute;
    left: 258.43px;
    top: 760.61px;
    width: 626.75px;
    height: 168.12px;
    z-index: 4;
    .pcm-a-qr-bg {
      width: 626.75px;
      height: 168.12px;
    }
    .pcm-a-qr {
      position: absolute;
      left: 47.79px;
      top: 23.75px;
      width: 126.28px;
      height: 120.61px;
      object-fit: contain;
      background: #fff;
    }
  }
  .pcm-a-header {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 62px;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 107px 0 173.59px;
    border-radius: 0 0 20px 20px;
    background: rgba(60, 31, 6, 0.7);
  }
  .pcm-a-logo {
    position: relative;
    width: 132.63px;
    height: 62px;
  }
  .pcm-a-logo-icon {
    position: absolute;
    left: 0;
    top: 6.67px;
    width: 42.4px;
    height: 42.4px;
    border-radius: 10.6px;
  }
  .pcm-a-logo-type {
    position: absolute;
    left: 44.56px;
    top: -13.36px;
    width: 88.07px;
    height: 88.07px;
  }
  .pcm-a-services {
    width: 468px;
    display: flex;
    align-items: center;
    gap: 35px;
  }
  .pcm-a-service {
    width: 127px;
    height: 30px;
    cursor: pointer;
  }
  .pcm-a-covers {
    position: absolute;
    left: 992.3px;
    top: 687.89px;
    width: 843px;
    height: 275.39px;
    display: flex;
    gap: 21px;
    align-items: center;
    z-index: 5;
    pointer-events: none;
  }
  .pcm-a-cover {
    position: relative;
    width: 191px;
    height: 263px;
    flex-shrink: 0;
    &.featured {
      width: 200px;
      height: 275.39px;
    }
  }
  .pcm-a-cover-frame {
    position: absolute;
    left: -10.47%;
    top: -2.66%;
    width: 115.18%;
    height: 105.01%;
  }
  .pcm-a-cover-image {
    position: absolute;
    left: 1.6%;
    top: 1.31%;
    width: 96.79%;
    height: 97.38%;
    border-radius: 12px;
    object-fit: cover;
  }
}
</style>
